import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase'
import config from './firebaseRef'

firebase.initializeApp(config)

const userRef = firebase.database().ref('user')
async function checkUserProfile ({ uid, email }) {
  const snapshot = await userRef.child(uid).once('value')
  // .then(snapshot => {
  // })
  if (snapshot.val() == null) {
    userRef.child(uid).set({
      role: 'vendor',
      email
    })
  } else {
    store.dispatch('userProfile', snapshot.val())
  }
}

firebase.auth().onAuthStateChanged(user => {
  if (user) {
    // login success fires
    // console.log(user)
    checkUserProfile(user)
  }
  store.dispatch('user', user || {})
  // initial no log and loging-out fire
  store.dispatch('authed', user !== null)
})

const AUTH_STATE_AUTHING = 0
const AUTH_STATE_NOAUTH = 1
export const AUTH_STATE_AUTHED = 2
const storedState = {
  authState: AUTH_STATE_AUTHING,
  user: {},
  firmware: {
    category: '',
    custom: ''
  },
  isMibFilterStoreEmpty: true,
  mibFliterStore: {
    category: '',
    custom: '',
    family: ''
  }
}
const mutations = {
  authed (state, authed) {
    state.authState = authed ? AUTH_STATE_AUTHED : AUTH_STATE_NOAUTH
  },
  user (state, content) {
    state.user = {
      email: content.email
    }
  },
  userProfile (state, profile) {
    state.user = {
      ...state.user,
      ...profile
    }
  },
  mibInfoSelected (state, mibInfo) {
    // console.log('mutation mibInfoSelected')
    // console.log(mibInfo)
    state.mibFliterStore = mibInfo
    state.isMibFilterStoreEmpty = false
    // console.log(state.mibFliterStore)
  },
  deleteMibFilterInfo (state) {
    state.mibFliterStore = {
      category: '',
      custom: '',
      family: ''
    }
    state.isMibFilterStoreEmpty = true
    // console.log('deleteMibFilterInfo')
  },
  firmwareInfoSelected (state, firmwareInfo) {
    // console.log('firmwareInfoSelected', firmwareInfo)
    state.firmware = {
      ...state.firmware,
      ...firmwareInfo
    }
  },
  firmwareInfoDelete (state) {
    state.firmware = {
      ...state.firmware,
      ...{
        category: '',
        custom: ''
      }
    }
  }
}

Vue.use(Vuex)
export const store = new Vuex.Store({
  state: storedState,
  mutations,
  strict: process.env.NODE_ENV !== 'production'
})

export function login (...arg) {
  return firebase.auth().signInWithEmailAndPassword(...arg)
}

export function resetPassword (mail) {
  return firebase.auth().sendPasswordResetEmail(mail)
}

export function firebaseLogout () {
  return firebase.auth().signOut()
}
export function firebaseSetPwd (newPwd) {
  return firebase.auth().currentUser.updatePassword(newPwd)
}

function delay (sec = 1) {
  if (sec > 10) return // console.log('delay cannot bigger than 10s')
  return new Promise(resolve => {
    setTimeout(resolve, sec * 1000)
  })
}

export async function getAuthState () {
  // eslint-disable-next-line
  while (storedState.authState === AUTH_STATE_AUTHING) {
    await delay(1)
    // console.log('waiting auth')
  }
  return storedState.authState === AUTH_STATE_AUTHED
}

export function getFireBase () {
  return firebase
}

export function getDb () {
  return firebase.database()
}

export function getDbTime () {
  return firebase.database.ServerValue.TIMESTAMP
}

export function getFwSwitchRef () {
  return firebase.database().ref('firmware/switch/storage')
}

export function getNetworkModelRef () {
  return firebase.database().ref('network/model')
}

export function getNetworkFamilyRef () {
  return firebase.database().ref('productFamily')
}

export function getFWPiRef () {
  return firebase.database().ref('firmware/pi/storage')
}

export function getSwitchRef () {
  return firebase.database().ref('switch/registeration')
}

export function getSwitchHistory () {
  return firebase.database().ref('switch/history')
}

export function getSmartCtrlRef () {
  return firebase.database().ref('smart-controller/registeration')
}

export function getSmartCtrlHistory () {
  return firebase.database().ref('smart-controller/history')
}

export function getSmartCtrlActRef () {
  return firebase.database().ref('smart-controller/registerationChange')
}

export function getPMIB () {
  return firebase.database().ref('privateMIB')
}

export function getNewMib () {
  return firebase.database().ref('newPrivateMib').child('versions')
}

export async function getDownload(path) {
  const url = firebase.storage().ref(path).getDownloadURL()
    .then((url) => {
      // Insert url into an <img> tag to "download"
      // console.log("getDownload", url)
      return url
    })
    .catch((error) => {
      console.log("getDownload", error)
      return ""
    })
  return url
}

export function getModelForUI (model) {
  switch (model) {
    case 'ite':
      return 'ITE'
    case 'iteHome':
      return 'ITE Home'
    case 'aspeed':
      return 'Aspeed'
  }
}

export function getCustomForUI (custom) {
  switch (custom) {
    case 'intrising':
      return 'Intrising'
    case 'microsens_npd7':
      return 'NPD7'
    case 'sercomm_dragon':
      return 'Dragon'
    case 'gomax':
      return 'GoMax'
    case 'gofanco':
      return 'Gofanco'
    case 'general':
      return 'General'
    case 'lantech_lantech':
      return 'Lantech'
    case 'lantech_lantechLTE':
      return 'LantechLTE'
    case 'lantech_teslakom':
      return 'Teslakom'
    case 'lantech_21net':
      return '21net'
    case 'lantech_germany':
      return 'Germany'
    case 'lantech_optigo':
      return 'Optigo'
    case 'lantech_hytec':
      return 'Hytec'
    case 'lantech_lgu+':
      return 'LGU+'
    case 'lantech_ruf':
      return 'Ruf'
    case 'lantech_ltdp':
      return 'Ltdp'
    case 'lantech_tekdis':
      return 'Tekdis'
    case 'lantech_acrobel':
      return 'Acrobel'
    case 'lantech_trafsys':
      return 'Trafsys'
    case 'lantech_pandacom':
      return 'Pan Dacom'
    case 'lantech_pandacom1':
      return 'Pan Dacom1'
    case 'lantech_nomad':
      return 'NOMAD'
    case 'lantech_nec':
      return 'NEC'
    case 'lantech_ns':
      return 'NS'
    case 'lantech_mclaren':
      return 'McLaren'
    default:
      return null
  }
}

export function getCustomFromLabel (custom) {
  switch (custom) {
    case 'Intrising':
      return 'intrising'
    case 'NPD7':
      return 'microsens_npd7'
    case 'Dragon':
      return 'sercomm_dragon'
    case 'GoMax':
      return 'gomax'
    case 'Gofanco':
      return 'gofanco'
    case 'General':
      return 'lantech_general'
    case 'Lantech':
      return 'lantech_lantech'
    case 'LantechLTE':
      return 'lantech_lantechLTE'
    case 'Teslakom':
      return 'lantech_teslakom'
    case '21net':
      return 'lantech_21net'
    case 'Germany':
      return 'lantech_germany'
    case 'Optigo':
      return 'lantech_optigo'
    case 'Hytec':
      return 'lantech_hytec'
    case 'LGU+':
      return 'lantech_lgu+'
    case 'Ruf':
      return 'lantech_ruf'
    case 'Ltdp':
      return 'lantech_ltdp'
    case 'Tekdis':
      return 'lantech_tekdis'
    case 'Acrobel':
      return 'lantech_acrobel'
    case 'Pan Dacom':
      return 'lantech_pandacom'
    case 'Pan Dacom1':
      return 'lantech_pandacom1'
    case 'NOMAD':
      return 'lantech_nomad'
    case 'NEC':
      return 'lantech_nec'
    case 'McLaren':
      return 'lantech_mclaren'
    case 'NS':
      return 'lantech_ns'
  }
}

export function getCategoryFromLabel (custom) {
  // watch out here required Production Category mapping to Firmware Category
  switch (custom) {
    case 'OS1':
      return 'swix1'
    case 'OS2':
      return 'swix2'
    case 'Wireless':
      return 'wrouter'
    case 'OS3':
      return 'router'
    case 'OS4':
      return 'routerx'
    case 'OS5':
      return 'os5'
    case 'Carrier Switch':
      return 'carrier_switch'
    case 'OS2 Pro':
      return 'os2_nat'
    case 'OS2 Plus':
      return 'os2_plus'
    case 'Viewer':
      return 'viewer'
  }
}

export const filterOptions = {
  category: [
    { label: 'OS1', value: 'swix1' },
    { label: 'OS2', value: 'swix2' },
    { label: 'OS2 Pro (Old)', value: 'os2_nat' },
    { label: 'OS2 Pro', value: 'os2_plus' },
    { label: 'OS3', value: 'router' },
    { label: 'OS4', value: 'routerx' },
    { label: 'OS5', value: 'os5' },
    { label: 'Carrier Switch', value: 'carrier_switch' },
    { label: 'Wireless', value: 'wrouter' },
    { label: 'Viewer', value: 'viewer' },
  ],
  custom: [
    { label: 'Intrising', value: 'intrising' },
    { label: 'NPD7', value: 'microsens_npd7' },
    { label: 'Dragon', value: 'sercomm_dragon' },
    { label: 'Lantech', value: 'lantech_lantech' },
    { label: 'LantechLTE', value: 'lantech_lantechLTE' },
    { label: 'Teslakom', value: 'lantech_teslakom' },
    { label: '21net', value: 'lantech_21net' },
    { label: 'Germany', value: 'lantech_germany' },
    { label: 'Optigo', value: 'lantech_optigo' },
    { label: 'Hytec', value: 'lantech_hytec' },
    { label: 'LGU+', value: 'lantech_lgu+' },
    { label: 'Ruf', value: 'lantech_ruf' },
    { label: 'Ltdp', value: 'lantech_ltdp' },
    { label: 'Tekdis', value: 'lantech_tekdis' },
    { label: 'Acrobel', value: 'lantech_acrobel' },
    { label: 'Trafsys', value: 'lantech_trafsys' },
    { label: 'Pan Dacom', value: 'lantech_pandacom' },
    { label: 'Pan Dacom1', value: 'lantech_pandacom1' },
    { label: 'NOMAD', value: 'lantech_nomad' },
    { label: 'NEC', value: 'lantech_nec' },
    { label: 'NS', value: 'lantech_ns' },
    { label: 'McLaren', value: 'lantech_mclaren' },
    { label: 'Undefined', value: 'undefined' },
  ],
  status: {
    firmware: [
      { label: 'Release', value: 'release' },
      { label: 'Develop', value: 'develop' }
    ],
    product: [
      { label: 'Production', value: 'release' },
      { label: 'Develop', value: 'develop' }
    ]
  }
}

export const snmpOidDocOpts = {
  lantech: 'https://drive.google.com/open?id=0ByPOatSTzklcb1plUFZDWUEyazg'
}

export const naturalSorting = (data, key, option = 'asc') => {
  return option === 'asc'
    ? data.slice().sort((a, b) => a[key].replace(' ', '').localeCompare(b[key].replace(' ', ''), undefined, { numeric: true }))
    : data.slice().sort((a, b) => b[key].replace(' ', '').localeCompare(a[key].replace(' ', ''), undefined, { numeric: true }))
}

export const getIconSrc = (category) => {
  return {
    'smart-controller': '/static/svg/smart_controller.svg',
    swix1: '/static/svg/core1.svg',
    swix2: '/static/svg/core2.svg',
    os2_nat: '/static/svg/os2_nat.svg',
    os2_plus: '/static/svg/os2_plus.svg',
    wrouter: '/static/svg/ap.svg',
    router: '/static/svg/router.svg',
    routerx: '/static/svg/routerx.svg',
    os5: '/static/svg/os5.svg',
    carrier_switch: '/static/svg/carrier_switch.svg',
    viewer: '/static/svg/viewer.svg',
  }[category]
}



// WEBPACK FOOTER //
// ./src/index.js